import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const TaxaList = props => <DefaultDataTable data={props} />;
